import script from "./ComponentePorto.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentePorto.vue?vue&type=script&setup=true&lang=js"

import "./ComponentePorto.vue?vue&type=style&index=0&id=6d2bfc45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2bfc45"]])

export default __exports__